module.exports = __webpack_public_path__ + "img/result-04.3a58fc28.svg";